import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "fingerPrint" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M12 11C12 14.517 10.991 17.799 9.247 20.571M5.807 18.531L5.861 18.441C7.26352 16.2129 8.00523 13.6327 8 11C8 9.93913 8.42143 8.92171 9.17157 8.17157C9.92172 7.42142 10.9391 7 12 7C13.0609 7 14.0783 7.42142 14.8284 8.17157C15.5786 8.92171 16 9.93913 16 11C16 12.017 15.93 13.019 15.797 14M19.01 18.132C19.655 15.866 20 13.473 20 11C20.0003 9.59555 19.6309 8.21577 18.9289 6.99937C18.2269 5.78296 17.217 4.7728 16.0008 4.07045C14.7846 3.36809 13.4049 2.99828 12.0004 2.9982C10.596 2.99812 9.21629 3.36777 8 4.07M3 15.364C3.64 14.045 4 12.564 4 11C4 9.543 4.39 8.177 5.07 7M13.679 20.844C14.2962 19.6125 14.7958 18.3254 15.171 17L13.679 20.844Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }